"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignSealed = void 0;
function assignSealed(target, src) {
    Object.keys(src).forEach(function (key) {
        Object.defineProperty(target, key, {
            writable: true,
            enumerable: true,
            configurable: false,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            value: src[key],
        });
    });
}
exports.assignSealed = assignSealed;
//# sourceMappingURL=assignSealed.js.map